import { useEffect, useState } from "react";
import API_BASE_URL from "../API/ConfigAPI";
import { toast } from "react-toastify";

export default function useFacturation({ excludeAFaire = false } = {}) {
  const [facturations, setFacturations] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState("");
  const [activeTabs, setActiveTabs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // 1️⃣ Charger la liste des mois-année disponibles
  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`${API_BASE_URL}/home/api/mois_facturation_list/`, {
      headers: { Authorization: `Token ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        const monthValues = data.map((item) => item.value);
        setActiveTabs(monthValues);

        // Choisir automatiquement le dernier mois disponible
        if (monthValues.length > 0) {
          setSelectedMonth(monthValues[monthValues.length - 1]);
        }
      })
      .catch((error) => {
        console.error("Erreur chargement mois:", error);
        toast.error("Erreur lors du chargement des mois.");
      });
  }, []);

  // 2️⃣ Charger les facturations en fonction du mois sélectionné
  useEffect(() => {
    if (!selectedMonth) return;
    const token = localStorage.getItem("token");

    setIsLoading(true);
    fetch(
      `${API_BASE_URL}/home/api/facturations/?mois_facturation=${selectedMonth}`,
      {
        headers: { Authorization: `Token ${token}` },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        const filtered = excludeAFaire
          ? data.filter((f) => f.statut !== "A faire")
          : data;

        const enriched = filtered.map((f) => ({
          ...f,
          relance_count: 0,
        }));

        setFacturations(enriched);
      })
      .catch((error) => {
        console.error("Erreur de chargement des factures:", error);
        toast.error("Erreur de chargement des factures.");
      })
      .finally(() => setIsLoading(false));
  }, [selectedMonth, excludeAFaire]);
  return {
    facturations,
    setFacturations,
    selectedMonth,
    setSelectedMonth,
    activeTabs,
    isLoading,
  };
}
